// Mirrors backend recall_returns._recalled_units so the till can list recalls from the offline cache.
const unitsFor = (p) => {
  const batches = p.batches || [];
  const hit = batches.filter((b) => b.recalled && (b.quantity || 0) > 0);
  if (hit.length) return hit.map((b) => ({ batch_number: b.batch_number || '', quantity: b.quantity }));
  if (p.recall_locked && !batches.some((b) => b.recalled)) {
    const qty = batches.length
      ? batches.reduce((s, b) => s + Math.max(0, b.quantity || 0), 0)
      : (p.stock_quantity || 0);
    if (qty > 0) return [{ batch_number: '', quantity: qty }];
  }
  return [];
};

export const recalledOnShelf = (products) => {
  const items = (products || [])
    .filter((p) => p.is_active !== false)
    .map((p) => {
      const batches = unitsFor(p);
      return { product_id: p.product_id, name: p.name, batches, units: batches.reduce((s, b) => s + b.quantity, 0) };
    })
    .filter((i) => i.units > 0)
    .sort((a, b) => b.units - a.units);
  return { items, total_units: items.reduce((s, i) => s + i.units, 0) };
};
